import { createContext } from 'react';

/**
 * @typedef {Object} UserData
 * @property {string | number} [id]
 * @property {string} [username]
 * @property {string} [display_name]
 * @property {string} [token]
 * @property {{ country_code?: string, display_name?: string }} [options]
 */

export const UserContext = createContext(/** @type {UserData} */ ({}));
